import { useMutation } from "@apollo/client/react";
import FormWithInlineErrors from "components/controls/FormWithInlineErrors";
import EditablePlannedBreakRow from "components/pages/plannedBreaks/EditablePlannedBreakRow";
import { insertPlannedBreak } from "hooks/apollo/plannedBreak/helpers/handleUpdatePlannedBreaks";
import { CreatePlannedBreak } from "hooks/apollo/plannedBreak/plannedBreak.gql";
import React from "react";
import DateTime from "utils/DateTime";
import Time from "utils/Time";

export default function NewPlannedBreak({ plannedBreakId, onRemoveNewPlannedBreak }) {
  const [createPlannedBreak] = useMutation(CreatePlannedBreak);

  const handleSave = ({ id, name, days, startTime, endTime, lineIds }) => {
    const updatedStartTime = Time.to24Hour(startTime);
    const updatedEndTime = Time.to24Hour(endTime);
    const updatedDays = {};
    DateTime.DAYS_OF_WEEK.forEach((day) => {
      updatedDays[day] = days.includes(day);
    });

    return createPlannedBreak({
      update: (proxy, { data }) => {
        const newPlannedBreak = data.createPlannedBreak.plannedBreak;

        insertPlannedBreak(newPlannedBreak, proxy);
      },
      variables: {
        endTime: updatedEndTime,
        id,
        lineIds,
        name,
        startTime: updatedStartTime,
        ...updatedDays,
      },
    });
  };

  const removeNewPlannedBreak = () => {
    onRemoveNewPlannedBreak(plannedBreakId);
  };

  return (
    <FormWithInlineErrors
      initialValues={{
        days: [],
        endTime: null,
        id: plannedBreakId,
        lineIds: [],
        name: "",
        startTime: null,
      }}
      onAfterSave={removeNewPlannedBreak}
      onSave={handleSave}
    >
      {({ dirty }) => (
        <EditablePlannedBreakRow dirty={dirty} onCancel={removeNewPlannedBreak} testId="new-planned-break-row" />
      )}
    </FormWithInlineErrors>
  );
}
